module.exports = __webpack_public_path__ + "static/media/trailer.915a00e2.avif";